import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Force dark mode - prevent any light mode from system preferences
// Apply the warm-neutral (cream paper) theme site-wide.
document.documentElement.classList.add('theme-warm');
document.documentElement.classList.remove('dark');
document.documentElement.style.colorScheme = 'light';

createRoot(document.getElementById("root")!).render(<App />);
